import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  constructor( 
    public router: Router,
    private apiService: ApiService) { }

  ngOnInit(): void {
   
    
    
  }
  goto(path){
    this.router.navigateByUrl(path);
  }

}
